export default __webpack_public_path__ + "fcf0085736da07f7015bc81faee0dcd6.svg";